define("media/components/media/table/sortable-header-cell", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component"], function (_exports, _component, _templateFactory, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <th class={{if this.isActive "is--active"}} {{on "click" (fn @toggleSort @field)}} ...attributes>
    <span class="u--float--left">
      {{@name}}
    </span>
    {{#if this.isActive}}
      {{#if this.isAscending}}
        {{svg-jar "arrow-up" class="o--icon--xs u--float--right"}}
      {{else}}
        {{svg-jar "arrow-down" class="o--icon--xs u--float--right"}}
      {{/if}}
    {{else}}
      {{svg-jar "arrow-sort" class="o--icon--xs u--float--right"}}
    {{/if}}
  </th>
  */
  {
    "id": "9+FKYcMs",
    "block": "[[[11,\"th\"],[16,0,[52,[30,0,[\"isActive\"]],\"is--active\"]],[17,1],[4,[38,1],[\"click\",[28,[37,2],[[30,2],[30,3]],null]],null],[12],[1,\"\\n  \"],[10,1],[14,0,\"u--float--left\"],[12],[1,\"\\n    \"],[1,[30,4]],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[30,0,[\"isActive\"]],[[[41,[30,0,[\"isAscending\"]],[[[1,\"      \"],[1,[28,[35,3],[\"arrow-up\"],[[\"class\"],[\"o--icon--xs u--float--right\"]]]],[1,\"\\n\"]],[]],[[[1,\"      \"],[1,[28,[35,3],[\"arrow-down\"],[[\"class\"],[\"o--icon--xs u--float--right\"]]]],[1,\"\\n\"]],[]]]],[]],[[[1,\"    \"],[1,[28,[35,3],[\"arrow-sort\"],[[\"class\"],[\"o--icon--xs u--float--right\"]]]],[1,\"\\n\"]],[]]],[13]],[\"&attrs\",\"@toggleSort\",\"@field\",\"@name\"],false,[\"if\",\"on\",\"fn\",\"svg-jar\"]]",
    "moduleName": "media/components/media/table/sortable-header-cell.hbs",
    "isStrictMode": false
  });

  class SortableHeaderCellComponent extends _component2.default {
    get isActive() {
      return this.isAscending || this.isDescending;
    }

    get isAscending() {
      return this.args.sortDefinition[0] === `${this.args.field}:asc`;
    }

    get isDescending() {
      return this.args.sortDefinition[0] === `${this.args.field}:desc`;
    }

  }

  _exports.default = SortableHeaderCellComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SortableHeaderCellComponent);
});